import useGroupByPricingType, { TakerMarketGroupData } from './useGroupByPricingType';
import useTakerMarkets from './useTakerMarkets';

const useTakerMarketsGroups = (): TakerMarketGroupData => {
  const { data: takerMarkets = [] } = useTakerMarkets();
  const { groupByPricingType } = useGroupByPricingType();
  const takerMarketTabData = groupByPricingType(takerMarkets);

  return takerMarketTabData;
};

export default useTakerMarketsGroups;
